module.exports = __webpack_public_path__ + "img/user-icon3.060b0a73.png";